import BaseService from "services/base";
import { get } from "utils/lodash";
import { USER_SELECTION } from "./constant";
import { TypeUserModel } from "types/model/User";

// Import GraphQL queries and mutations directly
import { ME_USER_QUERY } from "graphql/queries/auth";
import {
  USER_LOGIN_LOCAL_MUTATION,
  REGISTER_MUTATION,
  VERIFY_REGISTRATION_MUTATION,
  RESEND_OTP_MUTATION,
  FORGOT_PASSWORD_MUTATION,
  RESET_PASSWORD_MUTATION,
  SOFT_DELETE_ACCOUNT_MUTATION,
  REFRESH_TOKEN_MUTATION,
  USER_LOGIN_WITH_GOOGLE_MUTATION
} from "graphql/mutations/auth";

interface LoginResponse {
  data: {
    token: string;
    user: TypeUserModel;
  };
}

class AuthService extends BaseService {
  async me() {
    return this.custom(
      {
        typeQL: "query",
        PATH_RESPONSE: {
          DATA: "data.meUser.user",
          PARAMS: "",
        },
      },
      ME_USER_QUERY
    );
  }
  async loginWithEmailPassword(options: { email: string; password: string }) {
    // userLoginLocal
    const { email, password } = options;
    let response: LoginResponse | null = null;
    try {
      response = await this.custom(
        {
          typeQL: "mutation",
          PATH_RESPONSE: {
            DATA: "data.userLoginLocal",
            PARAMS: "",
          },
          log: true,
          variables: {
            emailOrPhone: email,
            password: password
          }
        },
        USER_LOGIN_LOCAL_MUTATION
      );
    } catch (error) {
      console.error("Error login:", JSON.stringify(error));
      throw error;
    }
    return response;
  }
  async register(options: { email: string; password: string }) {
    const nameQuery = "register";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
        },
        input: {
          email: get(options, "email", ""),
          password: get(options, "password", ""),
        },
      },
      REGISTER_MUTATION
    );
  }
  async verifyRegistration(options: { email: string; otp: string }) {
    const nameQuery = "verifyRegistration";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
          ERRORS: "errors",
        },
        input: {
          email: get(options, "email", ""),
          otp: get(options, "otp", ""),
        },
      },
      VERIFY_REGISTRATION_MUTATION
    );
  }
  async resendOTP(options: { email: string }) {
    const nameQuery = "resendOTP";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
          ERRORS: "errors",
        },
        input: {
          email: get(options, "email", ""),
        },
      },
      RESEND_OTP_MUTATION
    );
  }
  async forgotPassword(options: { email: string }) {
    const nameQuery = "forgotPassword";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
          ERRORS: "errors",
        },
        input: {
          email: get(options, "email", ""),
        },
      },
      FORGOT_PASSWORD_MUTATION
    );
  }
  async resetPassword(options: {
    email: string;
    otp: string;
    newPassword: string;
  }) {
    const nameQuery = "resetPassword";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
          ERRORS: "errors",
        },
        input: {
          email: get(options, "email", ""),
          otp: get(options, "otp", ""),
          newPassword: get(options, "newPassword", ""),
        },
      },
      RESET_PASSWORD_MUTATION
    );
  }
  async softDeleteAccount() {
    const nameQuery = "softDeleteAccount";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
          ERRORS: "errors",
        },
      },
      SOFT_DELETE_ACCOUNT_MUTATION
    );
  }
  async refreshToken(token?: string) {
    const nameQuery = "refreshTokenUser";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
          ERRORS: "errors",
        },
        token,
        log: true,
      },
      REFRESH_TOKEN_MUTATION
    );
  }
  async userLoginWithGoogle(options: { idToken: string }) {
    const nameQuery = "userLoginWithGoogle";
    return this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
          PARAMS: "",
          ERRORS: "errors",
        },
        data: {
          idToken: get(options, "idToken", ""),
        },
      },
      USER_LOGIN_WITH_GOOGLE_MUTATION
    );
  }
}
const Instance = new AuthService();
export default Instance;
